import React from "react";
import {Typography, Button, Modal, Row, Col, Radio, Checkbox} from "antd";
import InputText from "components/InputText";
import {API_BASE_URL, signup} from "api/api";
import { validatePassword, validateEmail } from "utils/utils";
import {displayError, displayGenericError} from "common/notifications";
import {Form} from "antd";
import LoadingIndicator from "../LoadingIndicator";
import BrdgxCountrySelector from "../selector/BrdgxCountrySelector";
import {getBankCode, getCountryList} from "../../api/api";

import CaptchaModal from "./CaptchaModal";
import GoogleCaptchaComponent from "./GoogleCaptchaComponent";
const { Text } = Typography;

export default class SignUpModal extends React.Component {

  state = {
    firstName: "",
    lastName: "",
    businessName:"",
    email: "",
    password: "",
    confirmPassword: "",
    signupMessage: "",
    customerAccountType:'PERSONAL',
    isLoading: false,
    requiredFields:{
      firstName: true,
      email:true,
      lastName: true,
      password:true,
      businessName:true,
      confirmPassword: true
    },
    tcChecked:false,
    countries:[{countryCode:'C001', country:'SINGAPORE',isoCodeAlpha2:'SG'},
      {countryCode:'C006', country:'HONG KONG',isoCodeAlpha2:'HK'}, {
        countryCode:'C002', country:'MALAYSIA',isoCodeAlpha2:'MY'}],
    country: 'C001',
    visibleCaptcha:true,
    googleResponse:''
  };

  loopPullDataWithCountryCode = () => {
    let temp = this;
    setTimeout(function () {
      if (localStorage.getItem("countryCode") == null) {
        temp.loopPullDataWithCountryCode();

      } else {
        if (localStorage.getItem("countryCode") === 'CN' || localStorage.getItem("countryCode") === 'HK'){
          temp.setState({
            country: 'C006'
          })
        }
        else if (localStorage.getItem("countryCode") === 'MY'){
          temp.setState({
            country: 'C002'
          })
        }
      }
    }, 300)
  }

  componentDidMount() {

    this.loopPullDataWithCountryCode();

  }
  _signUp = () => {
    const { firstName, lastName, email, password, confirmPassword, businessName, customerAccountType, country, googleResponse } = this.state;
    let isPassValidation = true;

    if(this.state.customerAccountType === 'PERSONAL'){
      if (firstName.trim().length === 0) {
        isPassValidation = false;
      }
      if (lastName.trim().length === 0) {
        isPassValidation = false;
      }
    }else{
      if (businessName.trim().length === 0) {
        isPassValidation = false;
      }
    }
    if (!validateEmail(email)) {
      isPassValidation = false;
    }
    if (!validatePassword(password)) {
      isPassValidation = false;
    }

    if(!this.validateConfirmPassword(password, confirmPassword)){
      isPassValidation = false;
    }

    if(!isPassValidation){
      if(this.state.customerAccountType === 'PERSONAL'){
        this.setState({
            requiredFields:{...this.state.requiredFields,
            firstName:firstName.trim().length !== 0,
             lastName:lastName.trim().length !==0,
              email: validateEmail(email),
              password:validatePassword(password),
              confirmPassword:this.validateConfirmPassword(password, confirmPassword)
          }
        })
      }
      else if(this.state.customerAccountType === 'CORPORATE'){
        this.setState({
          requiredFields:{...this.state.requiredFields,
            businessName:businessName.trim().length !== 0,
            email: validateEmail(email),
            password:validatePassword(password)
          }
        })
      }

    }
    else if(!this.state.googleResponse){
      displayError("Please ticked captcha")
    }
   else {
      this.setState({
        isLoading:true,
        visibleCaptcha: false
      })


      signup({ firstName, lastName, email, password, businessName, customerAccountType, country , googleResponse})
          .then(() => {
            this.setState({
              visible: true,
              signupMessage: "Please confirm your email",
              isLoading: false,
              visibleCaptcha:true
            });
            this.props.handleOk();
          })
          .catch(error => {
            displayGenericError(error);
            this.setState({
              isLoading:false,
              visibleCaptcha:true
            })
          });
    }

    
  };
  handleCaptchaSolved = (token) => {
    console.log("waf token " + token);
    this.setState({
      isLoading:true
    })
    const {
      firstName,
      lastName,
      email,
      password,
      confirmPassword,
      businessName,
      customerAccountType,
      country
    } = this.state;
    window.AwsWafIntegration.fetch(API_BASE_URL + "/api/signup-customer-web-account", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({firstName, lastName, email, password, businessName, customerAccountType, country})
    }).then((res) => {
      if (res.status === 200) {
        this.setState({
          visible: true,
          signupMessage: "Please confirm your email",
          isLoading: false
        });
        this.props.handleOk();
      } else {
        console.log(res)
        res.json().then(errorData => {
          displayError(errorData.result);
          this.setState({
            isLoading:false
          })
        })
      }

    })

  }

  handleOk = () => {
    const { history } = this.props;
    history.push("/login?hide-signup-modal=true");
  };
  onCustomerAccountTypeChange = (event) =>{

    this.setState({
      customerAccountType: event.target.value
    })
  }
  validateConfirmPassword(password, confirmPassword){
    if(confirmPassword){
      return password === confirmPassword ? true : false; 
    }else{
      return false;
    }
    
  }
  onCancel = ()=>{
    this.setState({
      firstName: "",
      lastName: "",
      businessName:"",
      email: "",
      password: "",
    })
    this.props.onCancel();

  }
  onCountryChange = bankCountry => {
    this.setState({
      country: bankCountry,
    })
  }
  render() {
    return (
      <Modal
        className="bp-modal"
        title="Sign Up"
        visible={this.props.visible}
        onOk={this._signUp}
        okButtonProps={{ disabled: !this.state.tcChecked }}
        onCancel={this.onCancel}
        maskClosable={false}
        destroyOnClose={true}
        width="600px"
        style={{top: "10px"}}
      >
        <div className="sign-up-form">
          <div className={"inner"}>
            <h4 className="headline">
              <b>Sign up to experience the modern way to transfer your money.</b>
            </h4>
            <div className={"form-content"}>
              <Row gutter={16}>
                <Col>
                  <Form.Item label="Type">
                    <Radio.Group size="large" onChange={this.onCustomerAccountTypeChange}
                                  name="customerAccountType" value={this.state.customerAccountType}>
                      <Radio.Button value="PERSONAL" >Personal</Radio.Button>
                      <Radio.Button value="CORPORATE" optionType="button">Corporate</Radio.Button>

                    </Radio.Group>
                  </Form.Item>
                </Col>

              </Row>
              {this.state.customerAccountType === 'CORPORATE' && (
                <>
                <Row gutter={16}>
                  <Col lg={12} xs={24}>
                    <Form.Item
                        label="Business Name"
                        required="true"
                        validateStatus={this.state.requiredFields.businessName ? "success" : "error"}
                        help={this.state.requiredFields.businessName ? "" : "Please input your Business Name"}>
                    <InputText
                        size={"large"}
                        type="text"
                        value={this.state.businessName}
                        onChange={e =>
                            this.setState({ businessName: e.target.value ,
                              requiredFields: Object.assign(this.state.requiredFields, { ['businessName']: true })})}

                    />
                    </Form.Item>
                  </Col>
                </Row>
                  <Form.Item
                      required="true"
                      hasFeedback
                      label="Company Country"
                  >
                    <BrdgxCountrySelector
                        placeholder="Company Country"
                        style={{width: '100%'}}
                        size={"large"}
                        name="country"
                        countries={this.state.countries}
                        value={this.state.country}
                        onChange={country =>
                            this.onCountryChange(country)
                        }

                    />
                  </Form.Item>
                <Form.Item
                    label="Business email"
                    required="true"
                    validateStatus={this.state.requiredFields.email ? "success" : "error"}
                    help={this.state.requiredFields.email ? "" : "Please check your email"}>
                <InputText
                  size={"large"}
                  type="text"
                  value={this.state.email}
                  onChange={e => this.setState({ email: e.target.value,
                        requiredFields: Object.assign(this.state.requiredFields, { ['email']: true })})}
                />
                </Form.Item>
                </>
              )}
              {this.state.customerAccountType === 'PERSONAL' && (
                <>
                <Row gutter={16}>
                  <Col lg={12} xs={24}>
                    <Form.Item
                        label="First Name"
                        required="true"
                        validateStatus={this.state.requiredFields.firstName ? "success" : "error"}
                        help={this.state.requiredFields.firstName ? "" : "Please input your First Name"}>
                      <InputText
                          size={"large"}
                          type="text"
                          value={this.state.firstName}
                          onChange={e =>
                              this.setState({firstName: e.target.value,
                                requiredFields: Object.assign(this.state.requiredFields, { ['firstName']: true })})
                          }
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={12} xs={24}>
                    <Form.Item
                        label="Last Name"
                        required="true"
                        validateStatus={this.state.requiredFields.lastName ? "success" : "error"}
                        help={this.state.requiredFields.lastName ? "" : "Please input your Last Name"}>
                    <InputText
                      size={"large"}
                      type="text"
                      value={this.state.lastName}
                      onChange={e =>
                        this.setState({ lastName: e.target.value,
                          requiredFields: Object.assign(this.state.requiredFields, { ['lastName']: true })})
                      }
                    />
                    </Form.Item>
                  </Col>
                </Row>
                  <Form.Item
                      required="true"
                      hasFeedback
                      label="Country of Residence"
                  >
                    <BrdgxCountrySelector
                        placeholder="Country of Residence"
                        style={{width: '100%'}}
                        size={"large"}
                        name="country"
                        countries={this.state.countries}
                        value={this.state.country}
                        onChange={country =>
                            this.onCountryChange(country)
                        }

                    />
                  </Form.Item>
                <Form.Item
                    label="Email"
                    required="true"
                    validateStatus={this.state.requiredFields.email ? "success" : "error"}
                    help={this.state.requiredFields.email ? "" : "Please check your email"}>
                <InputText
                  size={"large"}
                  type="text"

                  value={this.state.email}
                  onChange={e => this.setState({ email: e.target.value ,
                    requiredFields: Object.assign(this.state.requiredFields, { ['email']: true })})}
                />
                </Form.Item>
                </>
              )}
              <Form.Item
                  label="Password"
                  required="true"
                  validateStatus={this.state.requiredFields.password ? "success" : "error"}
                  help={this.state.requiredFields.password ? "" : "Your password must be have at least 8 characters with 1 uppercase and 1 lowercase"}>
              <InputText
                size={"large"}
                type="password"
                value={this.state.password}
                onChange={e => this.setState({ password: e.target.value ,
                  requiredFields: Object.assign(this.state.requiredFields, { ['password']: true })})}
              />
              </Form.Item>
              <Form.Item
                  label="Confirm Password"
                  required="true"
                  validateStatus={this.state.requiredFields.confirmPassword ? "success" : "error"}
                  help={this.state.requiredFields.confirmPassword ? "" : "Your password is not matched"}>
              <InputText
                size={"large"}
                type="password"
                value={this.state.confirmPassword}
                onChange={e => this.setState({ confirmPassword: e.target.value ,
                  requiredFields: Object.assign(this.state.requiredFields, { ['confirmPassword']: true })})}
              />
              </Form.Item>
            </div>
            <Checkbox
                style={{marginBottom: "5px"}}
                onChange={e => this.setState({ tcChecked: e.target.checked })}
                checked={this.state.tcChecked}
            >
            <Text >
              By Signing up, I agree with&nbsp;
              <a href="https://brdgx.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer">Terms & Conditions</a> and&nbsp;
              <a href="https://brdgx.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a> of Brdgx.
            </Text>
            </Checkbox>
            {/*{this.state.visibleCaptcha && (*/}
            {/*    <CaptchaModal*/}

            {/*        onSuccess={this.handleCaptchaSolved}*/}
            {/*    />*/}
            {/*)}*/}
            {(this.state.visibleCaptcha && (
            <GoogleCaptchaComponent responseToken={(e) => {

              this.setState({
                googleResponse: e
              })
            }} resetCaptcha={(e) => {
              this.setState({
                googleResponse: ''
              })
            }}
            ></GoogleCaptchaComponent>
                  ))}
          </div>
        </div>
      </Modal>
    );
  }
}
